import toast from 'react-hot-toast';
import { AlertAction, AlertTypes } from './alerts.actions';

export default function alertsReducer(state: any = {}, action: AlertAction) {
  switch (action.type) {
    case AlertTypes.Success:
      toast.success(action.text);
      return state;
    case AlertTypes.Error:
      toast.error(action.text);
      return state;
    case AlertTypes.Info:
      toast(action.text);
      return state;
    default:
      return state;
  }
}
